import { render, staticRenderFns } from "./DashboardWidgetDepositNotifications.vue?vue&type=template&id=ed88f25e&scoped=true&lang=pug&"
import script from "./DashboardWidgetDepositNotifications.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetDepositNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetDepositNotifications.vue?vue&type=style&index=0&id=ed88f25e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed88f25e",
  null
  
)

/* custom blocks */
import block0 from "./DashboardWidgetDepositNotifications.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports